import { TemplateData, TemplateParams } from '.';

const courseAccess = ({
  defaultPlaceholders,
  messages,
  serverConfig
}: TemplateParams): TemplateData => ({
  category: 'courses',
  email: {
    buttonEnabled: true,
    buttonLink: '{{courseUrl}}',
    buttonText: '{{courseTitle}}',
    content: `
      <p>
        ${messages.courseAccessInvitedToCourse}
        ${messages.courseAccessJoinCourse}
      </p>`,
    contentAfterButton: `
      <p>
        ${messages.courseFindAllCourses}
        ${
          serverConfig.authEnableLocalLogin &&
          !serverConfig.emailHidePasswordResetInfo
            ? messages.emailResetPasswordContent
            : ''
        }
      </p>
      <p>
        ${messages.emailSignatureText}
      </p>`,
    footnote: `${messages.emailContentClarification} {{contactEmail}}`,
    heading: messages.emailGreeting,
    subject: `{{siteName}}: ${messages.courseAccessToCourse}`
  },
  placeholders: {
    courseTitle: {
      label: messages.coursesCourseTitle,
      example: 'Test course'
    },
    courseUrl: {
      label: messages.commonCourseLink,
      example: `${serverConfig.adminUrl}/courses/test-course`
    },
    ...defaultPlaceholders
  },
  title: messages.emailTypeCourseAccess
});

export default courseAccess;
